import { surveyLocalization } from "../surveyStrings";

export var indonesianStrings = {
  pagePrevText: "Sebelumnya",
  pageNextText: "Selanjutnya",
  completeText: "Selesai",
  startSurveyText: "Mulai",
  otherItemText: "Lainnya (jelaskan)",
  noneItemText: "Tidak Ada",
  selectAllItemText: "Pilih Semua",
  progressText: "Halaman {0} dari {1}",
  emptySurvey: "Tidak ada halaman atau pertanyaan dalam survei.",
  completingSurvey: "Terima kasih telah menyelesaikan survei!",
  completingSurveyBefore:
    "Catatan kami menunjukkan bahwa Anda telah menyelesaikan survei ini.",
  loadingSurvey: "Memuat survei...",
  optionsCaption: "Pilih...",
  value: "nilai",
  requiredError: "Silahkan jawab pertanyaan berikut.",
  requiredErrorInPanel: "Silahkan jawab setidaknya satu petanyaan.",
  requiredInAllRowsError: "Silahkan jawab pertanyaan pada semua baris.",
  numericError: "Nilai harus berupa angka.",
  textMinLength: "Silahkan masukkan setidaknya {0} karakter.",
  textMaxLength: "Silahkan masukkan kurang {0} karakter.",
  textMinMaxLength: "PSilahkan masukkan lebih dari {0} dan kurang dari {1} karakter.",
  minRowCountError: "Silahkan isi setidaknya {0} baris.",
  minSelectError: "Silahkan pilih setidaknya {0} varian.",
  maxSelectError: "Silahkan pilih tidak lebih dari {0} varian.",
  numericMinMax: "'{0}' harus sama dengan atau lebih dari {1} dan harus sama dengan atau kurang dari {2}",
  numericMin: "'{0}' harus sama dengan atau lebih dari {1}",
  numericMax: "'{0}' harus sama dengan atau kurang dari {1}",
  invalidEmail: "Silahkan masukkan e-mail yang benar.",
  invalidExpression: "Ekspresi: {0} harus mengembalikan 'benar'.",
  urlRequestError: "Permintaan mengembalikan kesalahan '{0}'. {1}",
  urlGetChoicesError: "Permintaan mengembalikan data kosong atau properti 'path' salah.",
  exceedMaxSize: "Ukuran berkas tidak boleh melebihi {0}.",
  otherRequiredError: "Silahkan masukkan nilai lainnnya.",
  uploadingFile: "Berkas Anda sedang diunggah. Silahkan tunggu beberapa saat atau coba lagi.",
  loadingFile: "Memuat...",
  chooseFile: "Pilih berkas...",
  confirmDelete: "Apakah Anda ingin menghapus catatan?",
  keyDuplicationError: "Nilai harus unik.",
  addColumn: "Tambah kolom",
  addRow: "Tambah baris",
  removeRow: "Hapus",
  addPanel: "Tambah baru",
  removePanel: "Hapus",
  choices_Item: "item",
  matrix_column: "Kolom",
  matrix_row: "Baris",
  savingData: "Hasil sedang disimpan pada server...",
  savingDataError: "Kesalahan terjadi dan kami tidak dapat menyimpan hasil.",
  savingDataSuccess: "Hasil telah sukses disimpan!",
  saveAgainButton: "Coba lagi",
  timerMin: "menit",
  timerSec: "detik",
  timerSpentAll: "Anda telah menghabiskan {0} pada halaman ini dan {1} secara keseluruhan.",
  timerSpentPage: "YAnda telah menghabiskan {0} pada halaman ini.",
  timerSpentSurvey: "Anda telah menghabiskan {0} secara keseluruhan.",
  timerLimitAll:
    "Anda telah menghabiskan {0} dari {1} pada halaman ini dan {2} dari {3} secara keseluruhan.",
  timerLimitPage: "Anda telah menghabiskan {0} dari {1} pada halaman ini.",
  timerLimitSurvey: "Anda telah menghabiskan {0} dari {1} secara keseluruhan.",
  cleanCaption: "Bersihkan",
  clearCaption: "Bersihkan",
  removeFileCaption: "Hapus berkas ini"
};

surveyLocalization.locales["id"] = indonesianStrings;
surveyLocalization.localeNames["id"] = "Bahasa Indonesia";



// WEBPACK FOOTER //
// ./src/localization/indonesian.ts